import DashboardLayout from '../components/layout/DashboardLayout';
import Container from '../components/layout/Container';
import CustomFieldsManager from '../components/customer360/CustomFieldsManager';
import { useAuthContext } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';

export default function CustomFieldsAdminPage() {
  const { user } = useAuthContext();

  // Only admins can access this page
  if (user?.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return (
    <DashboardLayout>
      <Container className="py-6">
        <CustomFieldsManager />
      </Container>
    </DashboardLayout>
  );
}
